// * Map features:
import { AppMap } from "../utils/AppMap";
import * as turf from '@turf/turf';

// * Utils and handlers:
import { Message } from "../utils/Message";
import handleAddNewAreaToAge from "./handleAddNewAreaToAge";
import mapResponseData from "./mapResponseData";

/**
 * Checks if two polygons intersect.
 *
 * @param {Array} polygon1 - Tablica wierzchołków pierwszego wielokąta w formacie [[x, y], ...].
 * @param {Array} polygon2 - Tablica wierzchołków drugiego wielokąta.
 * @returns {Object|null} - Obiekt przecięcia w formacie GeoJSON lub null, jeśli brak przecięcia.
 */
const areaCheck = (polygon1, polygon2) => {
    polygon1.push(polygon1[0]);
    polygon2.push(polygon2[0]);

    const poly1 = turf.polygon([polygon1], { name: 'poly1' });
    const poly2 = turf.polygon([polygon2], { name: 'poly2' });

    return turf.intersect(poly1, poly2);
};

/**
 * Dodaje nowy obszar do bazy Age.
 *
 * @param {Array} array - Wierzchołki obszaru (format: [[x, y], ...]).
 * @param {string} name - Nazwa obszaru.
 * @param {Object} geometrySum - GeoJSON podsumowujący geometrie obszarów.
 * @param {Array} areaArray - Lista istniejących obszarów.
 * @param {Function} setAreaArray - Funkcja aktualizująca areaArray.
 * @param {number|string} id - Identyfikator żądania.
 * @param {string} code - Kod żądania.
 * @param {Function} setPowerKW - Funkcja ustawiająca wartość mocy (nieużywana obecnie).
 * @param {Function} setLoading - Funkcja ustawiająca stan ładowania.
 */

const addOwnArea = async (
    array,
    name,
    geometrySum,
    areaArray,
    setAreaArray,
    id,
    code,
    setPowerKW,
    setLoading
) => {
    setLoading(true);

    let intersection;
    try {
        const flatGeometrySum = geometrySum.coordinates.flat();
        intersection = areaCheck(array, flatGeometrySum);
    } catch (error) {
        console.error("Błąd podczas obliczania przecięcia:", error);
        Message.show("Błąd podczas analizy obszaru.", Message.severity.ERROR);
        setLoading(false);
        return;
    }

    if (!intersection) {
        Message.show(
            "Obszar nie może być dodany, ponieważ nie przecina się z żadnym z istniejących obszarów.",
            Message.severity.ERROR
        );
        setLoading(false);
        return;
    }

    if (intersection.geometry.type !== 'Polygon') {
        Message.show("Obszar nie jest jednolity i nie może być dodany.", Message.severity.ERROR);
        setLoading(false);
        return;
    }

    if (name === "") {
        name = `Obszar nr. ${areaArray.length + 1}`;
    }

    let response;

    try {
        response = await handleAddNewAreaToAge(intersection.geometry.coordinates, id, code, name);
    } catch (error) {
        console.error("Błąd podczas komunikacji z API:", error);
        Message.show("Wystąpił błąd podczas wysyłania danych do API.", Message.severity.ERROR);
        setLoading(false);
        return;
    }

    if (!response) {
        Message.show("Obszar nie mógł zostać dodany.", Message.severity.ERROR);
        AppMap.clearPoints();
        setLoading(false);
        return;
    }

    const newAreaArray = mapResponseData(response);
    setAreaArray(newAreaArray);
    
    AppMap.clearPoints();
    AppMap.drawMultiple(newAreaArray);
    setLoading(false);
};

export { addOwnArea };
